<template>
  <input
    ref="inputRef"
    v-model="formattedValue"
    :class="
      cn(
        'tw-flex tw-h-9 tw-w-full tw-rounded-md tw-border tw-border-neutral-200 tw-bg-transparent tw-px-3 tw-py-1 tw-text-sm tw-shadow-sm tw-transition-colors placeholder:tw-text-neutral-500 focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-ring-neutral-950 disabled:tw-cursor-not-allowed disabled:tw-opacity-50',
        errorClass
      )
    "
    :placeholder="placeholder"
    type="text"
  />
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { useCurrencyInput } from 'vue-currency-input';
import { cn } from '@/lib/utils';
import router from '@/router';

const props: any = defineProps({
  modelValue: {
    type: [Number, String],
    default: null,
  },
  options: {
    type: Object,
    default: () => ({
      locale: router.currentRoute.value.params.locale === 'en' ? navigator.language : 'de-DE',
      currency: 'EUR',
      currencyDisplay: router.currentRoute.value.params.locale === 'en' ? 'code' : 'symbol',
      precision: 2,
      hideCurrencySymbolOnFocus: false,
      hideGroupingSeparatorOnFocus: false,
      hideNegligibleDecimalDigitsOnFocus: false,
      autoDecimalDigits: false,
      exportValueAsInteger: false,
      autoSign: true,
      useGrouping: true,
      separator: '.',
      decimal: router.currentRoute.value.params.locale === 'en' ? '.' : ',',
    }),
  },
  placeholder: {
    type: String,
    default: '',
  },
  errorClass: {
    type: Object,
    default: () => {},
  },
});

let { inputRef, formattedValue, setValue, setOptions } = useCurrencyInput(props.options);

watch(
  () => props.modelValue,
  (value: any) => {
    setValue(value);
  }
);

watch(
  () => props.options,
  (options: any) => {
    setOptions(options);
  }
);
</script>
